import { Box, Stack } from '@mui/material'
import { SidebarDivider, SidebarItemWrapper, SidebarList } from './StyledSidebarComponents'
import type { ReactNode } from 'react'

type SidebarContentLayoutProps = {
  primaryItems: ReactNode
  resourceItems: ReactNode
  settingsItem: ReactNode
  footer: ReactNode
}

export const SidebarContentLayout = ({ primaryItems, resourceItems, settingsItem, footer }: SidebarContentLayoutProps) => (
  <Stack sx={{ height: '100%' }}>
    <Stack>
      <SidebarList>{primaryItems}</SidebarList>
      <SidebarDivider />
      <SidebarList>{resourceItems}</SidebarList>
      <SidebarDivider />
    </Stack>
    <Stack sx={{ mt: 'auto' }}>
      <Box sx={{ backgroundColor: 'bg.surface.default' }}>
        <SidebarItemWrapper>{settingsItem}</SidebarItemWrapper>
        <SidebarDivider />
      </Box>
      {footer == null ? null : (
        <Stack height={68} justifyContent="center" alignItems="center" sx={{ px: 3.5 }}>
          {footer}
        </Stack>
      )}
    </Stack>
  </Stack>
)
